export default __webpack_public_path__ + "static/media/shadow-hot-spring.a42abc35.png";